import { render, staticRenderFns } from "./SingleOrgSelection.vue?vue&type=template&id=4f86660e&"
import script from "./SingleOrgSelection.vue?vue&type=script&lang=ts&"
export * from "./SingleOrgSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports